import '../themes/default/body.scss';
import '../fonts/GalanoGrotesque-Light.woff';

import { StyledEngineProvider } from '@mui/material/styles';
import React, { ReactNode } from 'react';
import { Box } from 'rebass';
import { ThemeProvider } from 'theme-ui';

import defaultTheme from '../themes/default';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const Light = require(`sass-extract-loader?{"plugins": ["sass-extract-js"]}!./../themes/default/blue_colors.scss`);
// eslint-disable-next-line @typescript-eslint/no-var-requires
const Dark = require(`sass-extract-loader?{"plugins": ["sass-extract-js"]}!./../themes/default/black_colors.scss`);

interface Props {
  userTheme: string;
  children: ReactNode;
}

const GlobalStyle: React.FC<Props> = ({ userTheme = '', children }) => {
  const getSelectedThemeObject = (userTheme: string) => {
    switch (userTheme) {
      case 'Light':
        return Light;
      case 'Dark':
        return Dark;
      default:
        return Light;
    }
  };
  /*
  https://github.com/system-ui/theme-ui/issues/236
  */
  const themeWithColors = {
    ...defaultTheme,
    ...{ initialColorMode: userTheme },
    ...{ colors: { ...getSelectedThemeObject(userTheme), modes: defaultTheme.colors?.modes } },
  };

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={themeWithColors}>
        <Box variant="main">{children}</Box>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default GlobalStyle;
